(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('forms', {

            parent: 'app',
            url: '/forms?page&sort&search',
            data: {
                pageTitle: 'nasracApp.forms.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-forms/forms/forms.html',
                    controller: 'FormsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forms');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('forms-detail', {
            parent: 'forms',
            url: '/forms/{id}',
            data: {
               // authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.forms.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-forms/forms/forms-detail.html',
                    controller: 'FormsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forms');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Forms', function($stateParams, Forms) {
                    return Forms.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'forms',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('forms-detail.edit', {
            parent: 'forms-detail',
            url: '/detail/edit',
            /*data: {
                authorities: ['ROLE_USER']
            },*/
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('forms.new', {
            parent: 'forms',
            url: '/new',
            data: {
         //       authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                doctype: null,
                                docvisibility: null,
                                description: null,
                                fileupload: null,
                                fileuploadContentType: null,
                                uploaddate: null,
                                uploadedby: null,
                                noofdownloads: null,
                                filesize: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('forms');
                });
            }]
        })
        .state('forms.edit', {
            parent: 'forms',
            url: '/{id}/edit',
            data: {
     //           authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

            //for download functionality
            .state('forms.download', {
                parent: 'forms',
                url: '/{id}/download',
                onEnter: ['$stateParams', '$state','$window' ,'DataUtils','Forms', function($stateParams, $state,$window,DataUtils, Forms) {
                    var entity =  Forms.download({id : $stateParams.id}).$promise;

                    entity.then(function(res) {

                        //$scope.$emit('nasracApp:formsUpdate', res);

                        //console.log("download res", res);
                        //var file = new Blob([ res.fileupload ], {
                        var contentType = res.fileuploadContentType;
                        var sliceSize =  512;

                        var byteCharacters = atob(res.fileupload);
                        var byteArrays = [];

                        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                            var slice = byteCharacters.slice(offset, offset + sliceSize);

                            var byteNumbers = new Array(slice.length);
                            for (var i = 0; i < slice.length; i++) {
                                byteNumbers[i] = slice.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);

                            byteArrays.push(byteArray);
                        }

                        var blob = new Blob(byteArrays,{type: contentType});


                        var fileURL = URL.createObjectURL(blob);

                        /*console.log("content type resof url", fileURL);*/

                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';

                        a.download = res.title;
                        document.body.appendChild(a);
                        a.click();
                        $state.go('forms', null, { reload: 'forms' });
                    });
                }]
            })

        .state('forms.delete', {
            parent: 'forms',
            url: '/{id}/delete',
            data: {
     //           authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-delete-dialog.html',
                    controller: 'FormsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
